<div class="app-job">
  <div class="card m-3 p-6 text-center">
    <div id="instructions" class="mb-6 text-center text-lg">
      Open Job {{ id }} in the app <span class="pointer-icon">☝️</span>
    </div>
    <div id="link" class="text-center mb-1 text-base">Or go to the</div>
    <a
      href="/app/jobscreen/{{ id }}"
      class="text-base inline-block mx-auto w-auto bg-blue-500 font-bold text-white m-2 px-5 py-3 border-round-md cursor-pointer no-underline text-center"
      >Job Screen</a
    >
  </div>
</div>
